import { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';

const DebouncedInput = ({ value: propValue, onChange: propOnChange, disabled, placeholder, size = null, delay = 500, status }) => {
  const [localValue, setLocalValue] = useState(propValue ?? '');
  const typingTimeout = useRef(null);

  // Sync with external value changes (controlled usage)
  useEffect(() => {
    if (propValue !== undefined && propValue !== localValue) {
      setLocalValue(propValue);
    }
  }, [propValue]);

  const handleChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);

    if (typingTimeout.current) clearTimeout(typingTimeout.current);

    typingTimeout.current = setTimeout(() => {
      if (propOnChange) {
        propOnChange(val);
      }
    }, delay);
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (typingTimeout.current) clearTimeout(typingTimeout.current);
    };
  }, []);

  return (
    <Input
      size={size}
      value={localValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      status={status}
    />
  );
};

export default DebouncedInput;
